import { Notification } from '../../types';

import { NotificationStoreState } from './types';

export const notificationStoreSelector = {
  notifications: (state: NotificationStoreState): Notification[] =>
    state.notifications,
  isLoading: (state: NotificationStoreState): boolean => state.isLoading,
  isStale: (state: NotificationStoreState): boolean => state.isStale,
  finished: (state: NotificationStoreState): boolean => state.finished,
  showUnseenBadge: (state: NotificationStoreState): boolean =>
    state.showUnseenBadge,
  handleSeeNotificationPanel: (state: NotificationStoreState): (() => void) =>
    state.handleSeeNotificationPanel,
  handleHasSeenNotificationPanel: (
    state: NotificationStoreState
  ): (() => void) => state.handleHasSeenNotificationPanel,
  setReadNotification: (
    state: NotificationStoreState
  ): ((id: string) => void) => state.setReadNotification,
  deleteNotification: (state: NotificationStoreState): ((id: string) => void) =>
    state.deleteNotification,
  fetch: (state: NotificationStoreState): (() => Promise<void>) => state.fetch,
  init: (state: NotificationStoreState): (() => Promise<void>) => state.init,
  reset: (state: NotificationStoreState): (() => void) => state.reset,
  refetch: (state: NotificationStoreState): (() => Promise<void>) =>
    state.refetch,
  markAsStale: (state: NotificationStoreState): (() => void) =>
    state.markAsStale,
};
